export default __webpack_public_path__ + "static/media/E22.44d71f06.jpg";